import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const TicketSkeletonCard = () => (
  <div className={s.card}>
    <div className={s.top}>
      <Skeleton
        width={40}
        height={40}
        borderRadius={12}
      />
      <div className={s.info}>
        <Skeleton
          width="75%"
          height={16}
        />
        <Skeleton
          width="55%"
          height={12}
        />
      </div>
    </div>
    <div className={s.bottom}>
      <Skeleton
        width={88}
        height={20}
      />
      <Skeleton
        width={112}
        height={24}
        borderRadius={12}
      />
    </div>
  </div>
)
